import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ toggleTheme, darkMode }) => {
  const navItemStyle = {
    color: darkMode ? "#f8f9fa" : "#212529", // Light color for dark mode, dark color for light mode
  };

  return (
    <nav
      className={`navbar navbar-expand-lg ${
        darkMode ? "navbar-dark bg-dark" : "navbar-light bg-light"
      } sticky-top`}
    >
      <div className="container">
        <a className="navbar-brand" href="#welcome">
          <img src="../../favicon-32x32.png" alt="Joppe Dierckx" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="#welcome" style={navItemStyle}>
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about" style={navItemStyle}>
                Over mij
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#stage" style={navItemStyle}>
                Stage
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#projects" style={navItemStyle}>
                Realisaties
              </a>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-link nav-link"
                onClick={toggleTheme}
                style={{
                  ...navItemStyle,
                  border: "none",
                  background: "none",
                }}
                aria-label="Toggle theme"
              >
                <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
